import { render, staticRenderFns } from "./AssignmentSubmission.vue?vue&type=template&id=4c973f10&"
import script from "./AssignmentSubmission.vue?vue&type=script&lang=js&"
export * from "./AssignmentSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports